import React from "react";
import { Area } from "@ant-design/plots";
import styled from "styled-components";
import { formatDataNumberToen } from "../../helper/helper";

export default function DailyRevenueChartMagicWheel({ dataRevenueChart }) {
  const rawData = dataRevenueChart || [
    {
      chargeTime: "2010 Q4",
      value: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
    },
    {
      chargeTime: "2011 Q2",
      value: 2.8,
      total_reg_revenue: 1.2,
      total_renew_revenue: 1.6,
    },
    {
      chargeTime: "2012 Q1",
      value: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
    },
  ];

  // 👉 Chuyển dữ liệu sang long format
  const chartData = rawData.flatMap((d) => [
    { chargeTime: d.chargeTime, type: "Total Revenue", value: d.value || 0 },
    {
      chargeTime: d.chargeTime,
      type: "Register Revenue",
      value: d.total_reg_revenue || 0,
    },
    {
      chargeTime: d.chargeTime,
      type: "Renew Revenue",
      value: d.total_renew_revenue || 0,
    },
    {
      chargeTime: d.chargeTime,
      type: "Retail Revenue",
      value: d.total_retail_revenue || 0,
    },
  ]);

  const config = {
    data: chartData,
    xField: "chargeTime",
    yField: "value",
    seriesField: "type", // nhiều series
    smooth: true,
    isStack: false,
    color: ["#5B8FF9", "#52C41A", "#ffbb00","#00b0cb"], // Total, Register, Renew
    point: {
      size: 4,
      shape: "circle",
      style: {
        fill: "white",
        stroke: "#5B8FF9",
        lineWidth: 2,
      },
    },
    yAxis: {
      label: {
        formatter: (v) => ` ${formatDataNumberToen(+v)} `,
      },
    },
    tooltip: {
      formatter: (datum) => ({
        name: datum.type,
        value: ` ${formatDataNumberToen(+datum.value)} `,
      }),
    },
    areaStyle: { fillOpacity: 0.3 },
  };

  return (
    <Container className="p-3 pt-5 pb-5">
      <Area {...config} />
    </Container>
  );
}

const Container = styled.div``;
